// Frontend build version. `__APP_VERSION__` is injected by Vite at build time
// from frontend/package.json (see vite.config.ts `define`). Bump the package.json
// version on every release so the sidebar chip reflects what's deployed.
declare const __APP_VERSION__: string;

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
